<button
    class="notifications-bell"
    [class.notifications-bell--ringing]="isBellRinging()"
    [class.notifications-bell--ghost]="!!toastNotification()"
    (click)="onBellClick()"
>
    @if (newNav) {
        <i mine-icon name="bell" size="s" class="notifications-bell__svg"></i>
    } @else {
        <svg class="notifications-bell__svg">
            <use xlink:href="../../../assets/img/sprite.svg#icon-bell"></use>
        </svg>
    }
    @if (hasUnread()) {
        <span class="notifications-bell__dot" [class.notifications-bell__dot--pulsing]="isDotPulsing()"></span>
    }
</button>

@if (toastNotification(); as toast) {
    <button
        type="button"
        class="notifications-bell__toast"
        (click)="onToastClick()"
        [attr.aria-label]="'in-app-notifications.bellTooltip' | content">
        <div class="notifications-bell__toast-icon-wrapper">
            <svg class="notifications-bell__toast-bell" aria-hidden="true">
                <use xlink:href="../../../assets/img/sprite.svg#icon-bell"></use>
            </svg>
            <span class="notifications-bell__toast-dot"></span>
        </div>
        <div class="notifications-bell__toast-content">
            <span class="notifications-bell__toast-label">NOTIFICATION</span>
            <span class="notifications-bell__toast-body">{{ toast.body }}</span>
        </div>
        <svg class="notifications-bell__toast-arrow" aria-hidden="true">
            <use xlink:href="../../../assets/img/sprite.svg#icon-Arrow-right"></use>
        </svg>
    </button>
}
